<template>
  <div>
    <div>
      <router-link to="/">Home</router-link>
      <label class="labelBar"> / </label>
      <label> Cadastro/Acesso/Perfis</label>
    </div>
    <tab-navegacao />

    <v-container fluid
      ><v-row align="center">
        <v-col>
          <v-btn
            v-if="isAllowed(1)"
            color="info"
            to="/perfil/criar"
            class="ma-2 white--text"
          >
            NOVO
          </v-btn>
        </v-col>
        <v-col class="text-right">
          <v-checkbox
            v-if="perfis.length > 0"
            v-model="showAtivo"
            label="MOSTRAR ITENS INATIVOS"
          ></v-checkbox>
        </v-col>
        <v-col class="text-right">
          <v-btn
            @click="baixarlista()"
            v-if="perfis.length > 0"
            class="ma-2 blue--text"
            align="right"
          >
            <v-icon>mdi-file-excel</v-icon>
            Baixar planilha
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="filteredList"
        class="elevation-1"
        :loading="loading"
        loading-text="Buscando dados..."
        :search="search"
        :footer-props="{
          showFirstLastPage: true,
          itemsPerPageText: 'Items por página',
          itemsPerPageOptions: [5, 10, 15, -1],
        }"
      >
        <template v-slot:item.ativo="{ item }">
          {{ item.ativo ? "Ativo" : "Inativo" }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                class="mr-2"
                @click="editar(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span v-if="isAllowed(1)">Editar</span>
            <span v-else>Ver</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import TabNavegacao from "../../Tabs/TabCadastroUsuario";
import { downloadLista } from "../../../services/perfilService";
import { getUserRoles } from "@/services/loginService";

export default {
  name: "listaperfis",
  data() {
    return {
      loading: false,
      search: "",
      showAtivo: false,
      headers: [
        {
          text: "Id",
          align: "start",
          value: "id",
        },
        { text: "Perfil", value: "nome" },
        { text: "Permissão", value: "permissao" },
        { text: "Status", value: "ativo" },
        { text: "", value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    ...mapState("perfil", ["perfis"]),
    ...mapState("permissao", ["permissoesRegras"]),
    filteredList() {
      if (this.showAtivo == false) {
        return this.perfis.filter((prf) => {
          return (
            (prf.nome.toLowerCase().includes(this.search.toLowerCase()) ||
              prf.permissao
                .toLowerCase()
                .includes(this.search.toLowerCase())) &&
            prf.ativo === true
          );
        }).sort( function ( a, b ) { return b.id - a.id; } );
      } else {
        return this.perfis.filter((prf) => {
          return (
            prf.nome.toLowerCase().includes(this.search.toLowerCase()) ||
            prf.permissao.toLowerCase().includes(this.search.toLowerCase())
          );
        }).sort( function ( a, b ) { return b.id - a.id; } );
      }
    },
  },
  methods: {
    ...mapActions("perfil", ["atualizarPerfis", "atualizarPerfil"]),
    ...mapActions("permissao", ["atualizarPermissoesRegras"]),
    editar(perfil) {
      this.atualizarPerfil(perfil);
      if (this.isAllowed(1)) {
        this.$router.push(`/perfil/editar`);
      } else {
        this.$router.push(`/perfil/ver`);
      }
    },
    onChangePage(pageOfItems) {
      // update page of items
      this.pageOfItems = pageOfItems;
    },
    baixarlista() {
      downloadLista();
    },
    sort: function (s) {
      //if s == current sort, reverse
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === "asc" ? "desc" : "asc";
      } else this.currentSortDir = "asc";
      this.currentSort = s;
      this.loadBreweries();
    },
    doAjax() {
      if (!this.permissoes || this.permissoes.length == 0) {
        this.atualizarPermissoesRegras();
      }
    },
    async obterLista() {
      this.loading = true;
      await this.atualizarPerfis();
      this.loading = false;
    },
    isAllowed(id) {
      var regra = this.regras.find((r) => {
        return r.idModulo == id;
      });
      return regra != null && regra.escrita;
    },
  },
  created: function () {
    this.doAjax();
    this.obterLista();
    var roles = getUserRoles();
    if (roles) {
      this.regras = roles;
    }
  },
  components: {
    TabNavegacao,
  },
};
</script>